/**
 * Initialize bookmark dialog interactions.
 */
export function initBookmarks() {
	// Locate the shared bookmark dialog shell rendered in base template.
	const dialogElement = document.getElementById("bookmark-dialog");
	// Stop early if required runtime dependencies are unavailable.
	if (!dialogElement || !window.A11yDialog || !window.htmx) {
		return;
	}

	// HTMX swaps this region with fresh dialog markup per post and per save action.
	const contentElement = dialogElement.querySelector("#bookmark-dialog-content");
	if (!contentElement) {
		return;
	}

	// One dialog instance controls show/hide and focus trapping.
	const dialog = new window.A11yDialog(dialogElement);

	// Clear stale success/error notices whenever the dialog is closed.
	dialog.on("hide", function (event) {
		// dialogElement
		// 	.querySelectorAll(".wmb-bookmark-dialog__notice")
		// 	.forEach((noticeElement) => {
		// 		noticeElement.remove();
		// 	});
		dialogElement
			.querySelectorAll(".wmb-bookmark-dialog")
			.forEach((noticeElement) => {
				noticeElement.remove();
			});
		
	});

	// Open dialog from any bookmark trigger and load server-rendered state for that post.
	document.addEventListener("click", function (event) {
		const trigger = event.target.closest("[data-bookmark-trigger]");
		if (!trigger) {
			return;
		}

		// Prevent native click behavior; this interaction is fully JS-driven.
		event.preventDefault();

		// Every trigger declares which post it controls.
		const postId = parseInt(trigger.dataset.bookmarkPostId || "0", 10);
		if (!postId) {
			return;
		}

		// Show first for responsive UX, then hydrate body content via HTMX.
		loadBookmarkDialog(postId, contentElement);
		dialog.show();
	});

	// Authoritative post-save bookmark state comes from HX-Trigger response headers.
	document.body.addEventListener("wmb:bookmark-state", function (event) {
		const detail = event.detail || {};
		const payload = detail.value || detail;

		const postId = parseInt(payload.postId || "0", 10);
		if (!postId) {
			return;
		}

		const selectedListIds = Array.isArray(payload.selectedListIds)
			? payload.selectedListIds
				.map((value) => parseInt(value || "0", 10))
				.filter((id) => id > 0)
			: [];

		const isBookmarked =
			typeof payload.isBookmarked === "boolean"
				? payload.isBookmarked
				: selectedListIds.length > 0;

		setBookmarkTriggerState(postId, isBookmarked);
		removePostFromCurrentBookmarkListView(postId, selectedListIds);
	});

	// After every dialog content swap, re-init Alpine behavior and keep keyboard focus sensible.
	document.body.addEventListener("htmx:after:swap", function (event) {
		const swapTarget = event.detail?.ctx?.target || event.detail?.target || event.target;
		if (swapTarget !== contentElement) {
			return;
		}

		// if (window.Alpine) {
		// 	window.Alpine.initTree(contentElement);
		// }

		// const closeButton = dialogElement.querySelector(".dialog-close");
		// if (closeButton instanceof HTMLElement) {
		// 	closeButton.focus();
		// }
	
	
	});

	
}

function loadBookmarkDialog(postId, contentElement) {
	// Read localized ajax URL + nonce from global config.
	const config = getBookmarkConfig();
	if (!config.ajaxUrl || !config.nonce) {
		return;
	}

	// Request dialog fragment for the chosen post.
	window.htmx.ajax("POST", config.ajaxUrl, {
		target: contentElement,
		swap: "innerHTML",
		values: {
			// Backend endpoint returns dialog fragment for selected post.
			action: "wmb_bookmark_dialog",
			post_id: postId,
			nonce: config.nonce,
		},
	});
}

function setBookmarkTriggerState(postId, isBookmarked) {
	// A post can appear multiple times on one page; update each instance.
	document
		.querySelectorAll(`[data-bookmark-trigger][data-bookmark-post-id=\"${postId}\"]`)
		.forEach((button) => {
			button.setAttribute("aria-pressed", isBookmarked ? "true" : "false");
		});
}

function removePostFromCurrentBookmarkListView(postId, checkedListIds) {
	// This metadata exists only on single bookmark-list pages.
	const listView = document.querySelector("[data-bookmark-current-list-id]");
	if (!listView) {
		return;
	}

	// Only owners can mutate list contents inline on list view.
	const isOwned = listView.dataset.bookmarkCurrentListOwned === "1";
	if (!isOwned) {
		return;
	}

	// Parse list ID from page-level data attributes.
	const currentListId = parseInt(
		listView.dataset.bookmarkCurrentListId || "0",
		10,
	);
	if (!currentListId) {
		return;
	}

	// Keep card visible if post remains in the current list.
	const stillInCurrentList = checkedListIds.includes(currentListId);
	if (stillInCurrentList) {
		return;
	}

	// If viewing the current list page, remove the card when it is unsaved from that list.
	const listItem = document.querySelector(
		`[data-bookmark-list-item][data-bookmark-post-id=\"${postId}\"]`,
	);
	if (listItem) {
		// Remove stale card so list page reflects the new saved state.
		listItem.remove();
	}
}

function getBookmarkConfig() {
	// Localized in PHP as window.wmbBookmarks.
	return window.wmbBookmarks || {};
}
